<template>
    <div class="container_detail" v-loading="loading">
        <div class="breadcrumb_box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/college-library/index' }">院校库</el-breadcrumb-item>
                <el-breadcrumb-item>{{ detaiData.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="school_base_info">
            <div class="logo-section">
                <img :src="detaiData.logo" alt="Logo">
                <div>
                    <span class="school_name">{{ detaiData.name }}</span>
                    <div class="e_name">{{ detaiData.e_name }}</div>
                    <div class="tags">
                        <span class="tag_item" v-for="item in detaiData.univ_tag">{{ item }}</span>
                    </div>
                    <div class="school_address">
                        <i class="el-icon-map-location"></i>
                        <span class="address_name">{{ detaiData.city ? detaiData.country_name + '/' + detaiData.city :
        detaiData.country_name }}</span>
                    </div>
                </div>
            </div>
            <div class="rankings-section">
                <div class="ranking-item">
                    <p>{{ detaiData.qs_rank || '-' }}</p>
                    <span>2025 QS排名</span>
                </div>
                <div class="ranking-item">
                    <p>{{ detaiData.the_rank || '-' }}</p>
                    <span>2025 THE排名</span>
                </div>
                <div class="ranking-item">
                    <p>{{ detaiData.us_news_rank || '-' }}</p>
                    <span>2025 U.S.News</span>
                </div>
            </div>
        </div>
        <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane label="院校概况" name="introduction"></el-tab-pane>
                <el-tab-pane label="硕士专业" name="major"></el-tab-pane>
            </el-tabs>
            <div class="scroll_container">
                <div class="scroll_box">
                    <div class="introduce_colleges_content">
                        <div class="introduce_colleges_content_title" id="introduce-colleges-content-title">
                            <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt="">
                            <span>院校介绍</span>
                        </div>
                        <div class="introduce_colleges_content_text">
                            {{ detaiData.introduction }}
                        </div>
                    </div>
                    <div class="major_colleges_content">
                        <div class="major_colleges_content_title" id="major-colleges-content-title">
                            <img src="https://oss.kaoyanvip.cn/attach/file1738981959289.png" alt=""></img>
                            <span>硕士专业</span>
                        </div>
                        <div class="major_colleges_content_form">
                            <el-form :inline="true" :model="form">
                                <el-form-item>
                                    <el-cascader size="small" filterable clearable v-model="form.major_type"
                                        :options="marjor_options" placeholder="专业类型"
                                        :props="{ value: 'name', label: 'name' }"></el-cascader>
                                </el-form-item>
                                <el-form-item>
                                    <el-input size="small" style="width: 260px;" v-model="form.name" clearable
                                        placeholder="请输入专业名称（中/英文）"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="small" icon="el-icon-search"
                                        @click="handleSearch">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="table_container">
                            <el-table :data="tableData" style="width: 100%"
                                :header-cell-style="{ background: '#F6F6F8', color: '#8A8A8D' }">
                                <el-table-column label="专业" width="460px">
                                    <template slot-scope="{row}">
                                        <div style="color: #4678F8;font-weight: 600;font-size: 16px;cursor: pointer;"
                                            @click="handleToMajor(row, 'introduction')">{{ row.name }}</div>
                                        <div style="color: #8A8A8D;font-weight: 400;">{{ row.e_name }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="专业类型" align="center" width="260px">
                                    <template slot-scope="{row}">
                                        <div>{{ row.major_info && row.major_info.join(',') }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="专业热度排名" align="center" min-width="160px">
                                    <template slot-scope="{row}">
                                        <el-rate v-model="row.popular_rank" disabled></el-rate>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" min-width="160px">
                                    <template slot-scope="{row}">
                                        <el-button size="small" type="primary"
                                            @click="handleToMajor(row, 'introduction')">专业详情</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="pagination_box">
                            <div class="total_school">共<span>{{ pageObj.total }}</span>个专业</div>
                            <el-pagination @current-change="handleCurrentChange" background
                                :current-page.sync="pageObj.currentPage" :page-size="pageObj.pageSize"
                                layout=" prev, pager, next" :total="pageObj.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getSchoolDetail, getMajorTypeList, getMajorTableList } from '@/api/college-library'
import _ from 'lodash'
export default {
    name: 'CollegesDetail',
    data() {
        return {
            detaiData: {},
            loading: false,
            activeName: 'introduction',
            form: {
                major_type: [],
                name: ''
            },
            marjor_options: [],
            tableData: [],
            pageObj: {
                total: 0,
                currentPage: 1,
                pageSize: 10
            }
        }
    },
    created() {
        this.fetchSchoolDetail()
        this.getMajorTableListMethods()
        getMajorTypeList().then(res => {
            this.marjor_options = res.data
        })

    },
    mounted() {
        if (this.$route.query.tabType) {
            this.activeName = this.$route.query.tabType
            setTimeout(() => {
                const targetId = this.$route.query.tabType === 'introduction' ? 'introduce-colleges-content-title' : 'major-colleges-content-title';
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            }, 150)
        }
        // 添加滚动事件监听器
        setTimeout(() => {
            this.$nextTick(() => {
                const scrollBox = document.querySelector('.scroll_box');
                scrollBox.addEventListener('scroll', this.handleScroll);
            });
        }, 300)
    },
    beforeDestroy() {
        // 移除滚动事件监听器
        const scrollBox = document.querySelector('.scroll_box');
        scrollBox.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取学校详情
        fetchSchoolDetail() {
            this.loading = true
            getSchoolDetail(this.$route.params.school_id).then(res => {
                this.detaiData = res.data
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        // 切换tab
        handleTabClick(tab, event) {
            if (tab.index == 0) {
                let introduceDom = document.getElementById('introduce-colleges-content-title')
                introduceDom.scrollIntoView({
                    behavior: 'smooth'
                })
            } else {
                let majorDom = document.getElementById('major-colleges-content-title')
                majorDom.scrollIntoView({
                    behavior: 'smooth'
                })
            }
        },
        // 滚动事件监听器
        handleScroll: _.debounce(function () {
            const introduceDom = document.getElementById('introduce-colleges-content-title');
            const majorDom = document.getElementById('major-colleges-content-title');
            const scrollBox = document.querySelector('.scroll_box');
            const introduceRect = introduceDom.getBoundingClientRect();
            const majorRect = majorDom.getBoundingClientRect();
            const scrollBoxRect = scrollBox.getBoundingClientRect();

            if (majorRect.top <= scrollBoxRect.top + 50) {  // 增加容差范围
                this.activeName = 'major';
            } else if (introduceRect.bottom > scrollBoxRect.top - 50) {  // 增加容差范围
                this.activeName = 'introduction';
            }
        }, 200),  // 防抖时间设为200ms
        // 查询
        handleSearch() {
            const params = {
                name: this.form.name,
                major_info: this.form.major_type.join('/'),
                page: this.pageObj.currentPage,
                size: this.pageObj.pageSize
            };
            this.getMajorTableListMethods(params);
        },

        /**
         * 获取硕士专业列表数据的方法
         * @param {Object} params - 查询参数，默认为空对象
         */
        getMajorTableListMethods(params = {}) {
            // 调用 getMajorTableList API，传入学校ID和查询参数
            getMajorTableList(this.$route.params.school_id, params).then(res => {
                // 将返回的数据中的 results 赋值给 tableData
                this.tableData = res.data.results
                this.pageObj.total = res.data.count
            })
        },
        /**
         * 处理当前页码变化的事件
         * @param {number} val - 当前页码
         */
        handleCurrentChange(val) {
            // 更新当前页码
            this.pageObj.currentPage = val
            this.handleSearch()
        },
        //跳转到专业详情
        handleToMajor(row, tabType) {
            if (this.$store.getters.roles.includes('query.view_study_abroad_school_major_admin')) {
                const url = this.$router.resolve({
                    path: `/specialized-library/detail/${row.id}`,
                    query: {
                        tabType
                    }
                });
                window.open(url.href, '_blank');
            } else {
                this.$message({
                    message: '暂无相关权限',
                    type: 'warning'
                });
            }
        }
    }
}
</script>
<style lang="less" scoped>
::v-deep .el-input__inner:focus {
    border-color: #4678F8;
}
:global(.el-cascader-node.in-active-path),
:global(.el-cascader-node.is-active){
    color: #4678F8;
}
::v-deep .el-cascader__dropdown {
    .el-cascader-node:not(.is-disabled):focus,
    .el-cascader-node:not(.is-disabled):hover {
        background: #F5F7FA;
    }
}
::v-deep .el-cascader:hover .el-input__inner {
    border-color: #4678F8;
}
::v-deep .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #4678F8;
}
::v-deep .el-tabs__item.is-active,
::v-deep .el-tabs__item:hover {
    color: #4678f8;
    font-weight: 600;
}

::v-deep .el-tabs__item {
    font-weight: 600;
    font-size: 16px;
}

::v-deep .el-tabs__active-bar {
    background-color: #4678f8;
}

/* 修改活跃页码的背景色 */
::v-deep .el-pagination .el-pager li.active {
    background-color: #4678f8 !important;
    color: #fff !important;
}

::v-deep .el-pagination .el-pager li:hover {
    color: #4678f8 !important;
}

::v-deep .el-pagination .el-pager li {
    border: 1px solid #e5e5e5;
    background-color: #fff;
    border-radius: 4px;
}

::v-deep .el-table td,
::v-deep .el-table th.is-leaf {
    border-color: #eeeeee;
}

::v-deep .el-table--border::after,
::v-deep .el-table--group::after,
::v-deep .el-table::before {
    background-color: #eeeeee;
}

::v-deep .el-table--border,
::v-deep .el-table--group {
    border-color: #eeeeee;
}

.el-button--primary {
    background-color: #4678F8;
    border-color: #4678F8;

    &:hover {
        background-color: #6792ff;
        border-color: #6792ff;
    }
}

.container_detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #f7f7f8;

    .breadcrumb_box {
        margin: 16px 0 0 16px;

        ::v-deep .el-breadcrumb__inner.is-link:hover {
            color: #4678f8;
        }
    }

    .school_base_info {
        display: flex;
        justify-content: space-between;
        margin: 16px 16px 0;
        padding: 16px;
        background-color: #fff;
        border-radius: 4px;

        .logo-section {
            flex: 1;
            display: flex;
            align-items: center;

            img {
                width: 80px;
                height: 80px;
                margin-right: 16px;
                border-radius: 4px;
            }

            .school_name {
                font-size: 20px;
                color: #303030;
                font-weight: 600;
            }

            .e_name {
                font-size: 16px;
                color: #303030;
                margin: 10px 0;
            }

            .school_address {
                margin-top: 10px;
                color: #8A8A8D;
                font-size: 14px;

                i {
                    margin-right: 10px;
                }
            }
        }

        .rankings-section {
            flex: 1;
            display: flex;
            gap: 10px;
            justify-content: center;
            padding: 20px;
        }

        .ranking-item {
            background-color: #fff;
            border-radius: 16px;
            text-align: center;
            width: 240px;
            height: 108px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-size: cover;
            background-position: center;

            &:nth-child(1) {
                color: #D07AF5;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738981959467.png');
            }

            &:nth-child(2) {
                color: #FF6528;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738983925203.png');
            }

            &:nth-child(3) {
                color: #29BFFE;
                /* 背景图片居中铺满 */
                background-image: url('https://oss.kaoyanvip.cn/attach/file1738981959653.png');
            }
        }

        .ranking-item span {
            margin: 10px 0;
            font-size: 14px;
            color: #8A8A8D;
        }

        .ranking-item p {
            margin: 0;
            font-size: 24px;
            font-weight: bold;
        }

        .tags {
            display: flex;
            gap: 8px;
            margin-top: 10px;
            .tag_item{
                color: #53BC6B;
                padding: 3px 10px;
                font-size: 14px;
                background-color: #EDF8F0;
                border-radius: 4px;
            }
        }
    }

    .content {
        flex: 1;
        padding: 10px 20px 20px 20px;
        margin: 16px;
        background-color: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;

        .scroll_container {
            flex: 1;
            position: relative;
        }

        .scroll_box {
            width: 100%;
            height: 100%;
            overflow: auto;
            position: absolute;

            .table_container {
                overflow: hidden;
                border: 1px solid #eeeeee;
                border-radius: 8px;

                ::v-deep .el-table tr:last-child td {
                    border-bottom-color: transparent;
                }

                ::v-deep .el-table::before {
                    height: 0 !important;
                }
            }
        }

        .introduce_colleges_content {
            margin-top: 15px;

            .introduce_colleges_content_title {
                font-size: 16px;
                color: #303030;
                font-weight: 600;
                margin-bottom: 10px;

                img {
                    margin-right: 10px;
                }
            }

            .introduce_colleges_content_text {
                font-size: 14px;
                color: #303030;
                line-height: 1.5;
            }
        }

        .major_colleges_content {
            margin-top: 15px;

            .pagination_box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;

                ::v-deep .btn-prev,
                ::v-deep .btn-next {
                    background-color: #fff;
                }

                .total_school {
                    font-size: 14px;
                    color: #181818;

                    span {
                        color: #4678f8;
                        margin: 0 5px;
                    }
                }
            }

            .major_colleges_content_title {
                font-size: 16px;
                color: #303030;
                font-weight: 600;
                margin-bottom: 10px;

                img {
                    margin-right: 10px;
                }
            }

            .major_colleges_content_text {
                font-size: 14px;
                color: #303030;
                line-height: 1.5;
            }
        }
    }
}
</style>